// Centralized site data for Tampa Bay Pool Pros
export const SITE = {
  name: "Tampa Bay Pool Pros",
  shortName: "TB Pool Pros",
  established: "2020",
  experience: "25+ Years",
  phone: "+1 727-643-9404",
  phoneTel: "+17276439404",
  phoneDisplay: "(727) 643-9404",
  email: "tampabaypoolpros@gmail.com",
  facebook: "https://www.facebook.com/TampaBayPoolPros",
  googleReviews: "https://share.google/rOYxiTk24hlZ74p3H",
  canonicalDomain: "https://www.tbpoolpros.com",
  legacyDomain: "https://www.tampabaypoolpros.com",
  region: "Tampa Bay, Florida",
  emergency: "24/7 Pool Emergency Service",
  logo:
    "https://customer-assets.emergentagent.com/job_d5150541-0200-412c-b6e8-dd4165cb6378/artifacts/y1s6veko_image.png",
};

export const SERVICES = [
  {
    slug: "green-pool-cleanup",
    title: "Green Pool Cleanup",
    blurb:
      "Algae taking over? Our signature green-to-blue pool cleanup brings even the worst pools back fast.",
    icon: "Droplets",
    featured: true,
  },
  {
    slug: "pool-cleaning",
    title: "Pool Cleaning",
    blurb:
      "Professional pool cleaning that keeps your water crystal clear, balanced, and ready to swim.",
    icon: "Sparkles",
  },
  {
    slug: "weekly-pool-service",
    title: "Weekly Pool Service",
    blurb:
      "Reliable weekly pool service — skim, brush, vacuum, filter check, chemical balancing. Set it and forget it.",
    icon: "Calendar",
  },
  {
    slug: "pool-maintenance",
    title: "Pool Maintenance",
    blurb:
      "Full-spectrum pool maintenance to extend equipment life and protect your investment year-round.",
    icon: "Wrench",
  },
  {
    slug: "pool-filter-cleaning",
    title: "Pool Filter Cleaning",
    blurb:
      "Cartridge, sand, and DE pool filter cleaning that restores flow, clarity, and pressure.",
    icon: "Filter",
  },
  {
    slug: "pool-pump-cleaning",
    title: "Pool Pump Cleaning",
    blurb:
      "Pool pump cleaning, priming, and basket service for quieter, more efficient circulation.",
    icon: "Cog",
  },
  {
    slug: "pool-emergency",
    title: "24/7 Pool Emergency",
    blurb:
      "Storm damage, pump failure, or leak? Our 24/7 pool emergency line is one call away.",
    icon: "AlertTriangle",
  },
  {
    slug: "chemical-balancing",
    title: "Chemical Balancing",
    blurb:
      "Precise chlorine, pH, and stabilizer balancing for safe, comfortable, scale-free water.",
    icon: "FlaskConical",
  },
  {
    slug: "equipment-repair",
    title: "Equipment Repair",
    blurb:
      "Pumps, filters, heaters, salt cells, timers — we diagnose and repair on the spot when possible.",
    icon: "Hammer",
  },
];

export const CITIES = [
  {
    slug: "clearwater",
    name: "Clearwater",
    blurb:
      "From the beach communities to inland neighborhoods, Clearwater pools shine under our weekly care.",
  },
  {
    slug: "tarpon-springs",
    name: "Tarpon Springs",
    blurb:
      "Sponge Docks to Innisbrook — Tarpon Springs trusts us for spotless, sparkling pool water.",
  },
  {
    slug: "trinity",
    name: "Trinity",
    blurb:
      "Trinity homeowners count on prompt weekly service and seasoned green pool recovery.",
  },
  {
    slug: "dunedin",
    name: "Dunedin",
    blurb:
      "Dunedin's coastal humidity is no match for our pro-grade chemistry and filtration tune-ups.",
  },
  {
    slug: "palm-harbor",
    name: "Palm Harbor",
    blurb:
      "Palm Harbor pool owners love our flat-rate plans and friendly, on-time technicians.",
  },
  {
    slug: "oldsmar",
    name: "Oldsmar",
    blurb:
      "Quick response time across Oldsmar — from East Lake to Cypress Forest.",
  },
  {
    slug: "westchase",
    name: "Westchase",
    blurb:
      "Westchase pools get white-glove weekly service and proactive equipment care.",
  },
  {
    slug: "town-and-country",
    name: "Town and Country",
    blurb:
      "Reliable pool cleaning across Town and Country — every visit, every week.",
  },
  {
    slug: "odessa",
    name: "Odessa",
    blurb:
      "Odessa's larger backyard pools deserve our experienced, professional touch.",
  },
  {
    slug: "carrollwood",
    name: "Carrollwood",
    blurb:
      "Carrollwood homeowners trust Tampa Bay Pool Pros for crystal-clear results.",
  },
];

export const TESTIMONIALS = [];

export const POOL_TYPES = [
  "In-ground (concrete/gunite)",
  "In-ground (fiberglass)",
  "In-ground (vinyl liner)",
  "Above-ground",
  "Saltwater",
  "Screened/Caged",
  "Spa / Hot Tub",
  "Not sure",
];
